import { useState } from 'react'
import { useSelector } from 'react-redux'

import EnrolledFamilyView from './EnrolledFamilyView/EnrolledFamilyView'
import NewFamilyView from './NewFamilyView/NewFamilyView'
import classes from './ProgramsTab.module.scss'

const ProgramsTab = () => {
  const user = useSelector(state => state.user.current_user)
  const [isExploring, setIsExploring] = useState(false)

  return (
    <div className={classes.programsTab}>
      {user.communities.length === 0 || isExploring ? (
        <NewFamilyView onBack={isExploring ? () => setIsExploring(false) : null} />
      ) : (
        <EnrolledFamilyView onExplore={() => setIsExploring(true)} />
      )}
    </div>
  )
}

export default ProgramsTab
